import { useState } from "react";
import { MYPAGE_DATA_LIMIT } from "../../../../utils/config";
import { Link } from "react-router-dom";
import MypagePagination from "../common/MypagePagination";

const NewsDataTable = ({
  tableData,
  displayType,
  currentPage,
  setCurrentPage,
}) => {
  // 1ページの件数
  const [limit] = useState(MYPAGE_DATA_LIMIT);
  // あなたへのお知らせ
  const YourNews = 2;

  // 1ページに表示するデータ
  let dispData = tableData;
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  dispData = dispData.slice(offset, offset + Number(limit));

  return (
    <>
      {dispData.map((rData) => {
        return (
          <div
            key={rData.id}
            className={`p-course-item ${
              displayType === YourNews && !rData.is_read ? "unread" : ""
            }`}
          >
            <div className="p-course-left">
              <p className="p-course-date">{rData.date}</p>
            </div>
            <div className="p-course-right">
              <Link to={"/mypage/news/detail/" + rData.id}>
                <h2 className="p-course-ttl">{rData.title}</h2>
                {rData.content ? (
                  <span
                    className="text-break"
                    dangerouslySetInnerHTML={{
                      __html: rData.content.replace(/\r?\n/g, "<br/>"),
                    }}
                  />
                ) : (
                  <></>
                )}
                <>
                  {rData.reference_url1 ||
                  rData.reference_url2 ||
                  rData.reference_url3 ? (
                    <div className="mt-5">
                      <p>■URL</p>
                      <ul>
                        <li className="text-truncate">
                          {rData.reference_url1}
                        </li>
                        <li className="text-truncate">
                          {rData.reference_url2}
                        </li>
                        <li className="text-truncate">
                          {rData.reference_url3}
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              </Link>
            </div>
          </div>
        );
      })}
      <MypagePagination
        tableData={tableData}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
};

export default NewsDataTable;
